import cn from 'classnames'
import PropTypes from 'prop-types'

const Navbar = ({ children, isBanner }) => {
  return (
    <div className={cn('navbar', { '-isBanner': isBanner })}>
      {children}
    </div>
  )
}

Navbar.propTypes = {
  children: PropTypes.element,
  isBanner: PropTypes.bool,
}

export default Navbar
